import { CommonModule, isPlatformBrowser, NgOptimizedImage } from '@angular/common';
import {
 Component,
 EventEmitter,
 Inject,
 Input,
 OnInit,
 Output,
 PLATFORM_ID,
 WritableSignal,
 effect,
 forwardRef,
 inject,
 signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module'; import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
  selector: 'iho-card-city',
 standalone: true,
  imports: [CommonModule, FormsModule,NgOptimizedImage],
 templateUrl: './card-city.component.html',
 styleUrls: ['./card-city.component.scss'],
})
export class CardCityComponent implements OnInit {
 constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
  fallbackImage = 'assets/images/empty-city.jpg';
  @Input() dataList: any;
 ngOnInit(): void {
   
 }
  getSafeImage(url: string): string {
    return url?.length ? url : this.fallbackImage;
  }

}
